export default () => !!window.navigator.userAgent.match('Raspbian');
